import * as React from "react";
import Svg, { G, Rect, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_1096_12274)">
      <Rect
        x={3.15332}
        y={12.6938}
        width={12.4455}
        height={21.7796}
        transform="rotate(-42.5572 3.15332 12.6938)"
        fill={props.bgColor || "#C6D4FF"}
      />
      <Path
        opacity={0.2}
        d="M13.1306 14.2664C14.3891 13.1109 16.3461 13.1944 17.5016 14.4529C18.6571 15.7114 18.5736 17.6683 17.3151 18.8238C16.0566 19.9794 14.0997 19.8959 12.9442 18.6374C11.7886 17.3789 11.8721 15.4219 13.1306 14.2664Z"
        fill="black"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.098208}
      />
      <Path
        opacity={0.2}
        d="M6.7648 12.8479C6.72363 13.8128 6.38923 14.7417 5.80692 15.5111L3.22286 12.6968L6.03722 10.1127C6.55189 10.9289 6.80596 11.8829 6.7648 12.8479Z"
        fill="#A7BBF7"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.098208}
      />
      <Path
        opacity={0.2}
        d="M12.2595 7.80356C11.2945 7.7624 10.3656 7.42799 9.59623 6.84568L12.4106 4.26162L14.9946 7.07598C14.1785 7.59066 13.2244 7.84473 12.2595 7.80356Z"
        fill="#A7BBF7"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.098208}
      />
      <Path
        opacity={0.2}
        d="M27.2214 20.3933L24.4071 22.9774C23.8924 22.1612 23.6383 21.2071 23.6795 20.2422C23.7207 19.2773 24.0551 18.3483 24.6374 17.579L27.2214 20.3933Z"
        fill="#A7BBF7"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.098208}
      />
      <Path
        opacity={0.2}
        d="M18.1853 25.2867C19.1502 25.3279 20.0792 25.6623 20.8486 26.2446L18.0342 28.8287L15.4502 26.0143C16.2663 25.4997 17.2204 25.2456 18.1853 25.2867Z"
        fill="#A7BBF7"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.098208}
      />
      <Path
        d="M17.5378 14.4197C16.3639 13.1412 14.3759 13.0564 13.0974 14.2302C11.8189 15.4041 11.7341 17.3921 12.908 18.6706C14.0818 19.9491 16.0699 20.0339 17.3483 18.86C18.6268 17.6862 18.7116 15.6981 17.5378 14.4197Z"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.57133}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M3.15303 12.6938L18.0312 28.8981L27.2908 20.3962L12.4126 4.19201L3.15303 12.6938Z"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.57133}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.04709 10.037C6.58832 10.8724 6.85628 11.8554 6.81386 12.8499C6.77143 13.8444 6.42071 14.8011 5.8103 15.5874"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.57133}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.0704 7.08585C14.235 7.62708 13.2519 7.89505 12.2574 7.85262C11.2629 7.81019 10.3062 7.45947 9.51993 6.84906"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.57133}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24.3972 23.0531C23.856 22.2177 23.588 21.2346 23.6304 20.2401C23.6729 19.2456 24.0236 18.2889 24.634 17.5027"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.57133}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.3744 26.0045C16.2098 25.4632 17.1929 25.1953 18.1874 25.2377C19.1819 25.2801 20.1386 25.6308 20.9249 26.2412"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.57133}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Rect
        x={8.05542}
        y={7.68396}
        width={12.9272}
        height={22.6226}
        transform="rotate(-21.2786 8.05542 7.68396)"
        fill={props.bgColor || "#C6D4FF"}
      />
      <Path
        opacity={0.2}
        d="M17.1178 12.9664C18.7715 12.3224 20.6341 13.1408 21.2781 14.7945C21.9222 16.4482 21.1037 18.3108 19.45 18.9549C17.7963 19.5989 15.9337 18.7804 15.2897 17.1267C14.6456 15.4731 15.4641 13.6104 17.1178 12.9664Z"
        fill="black"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.102009}
      />
      <Path
        opacity={0.2}
        d="M11.4927 9.19429C11.0891 10.1127 10.4152 10.8858 9.56161 11.411L8.12139 7.7129L11.8195 6.27268C12.01 7.25664 11.8962 8.27585 11.4927 9.19429Z"
        fill="#244BBE"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.102009}
      />
      <Path
        opacity={0.2}
        d="M18.7109 6.38259C17.7925 5.97902 17.0194 5.30518 16.4942 4.45155L20.1923 3.01133L21.6325 6.70939C20.6486 6.89989 19.6294 6.78617 18.7109 6.38259Z"
        fill="#244BBE"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.102009}
      />
      <Path
        opacity={0.2}
        d="M28.4486 24.2087L24.7505 25.6489C24.56 24.665 24.6737 23.6458 25.0773 22.7273C25.4809 21.8089 26.1547 21.0358 27.0083 20.5106L28.4486 24.2087Z"
        fill="#244BBE"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.102009}
      />
      <Path
        opacity={0.2}
        d="M17.8578 25.5389C18.7763 25.9425 19.5493 26.6163 20.0745 27.4699L16.3764 28.9102L14.9362 25.2121C15.9202 25.0216 16.9394 25.1353 17.8578 25.5389Z"
        fill="#244BBE"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.102009}
      />
      <Path
        d="M21.3257 14.776C20.6714 13.0961 18.7792 12.2646 17.0993 12.9189C15.4194 13.5731 14.5879 15.4653 15.2421 17.1453C15.8964 18.8252 17.7886 19.6566 19.4685 19.0024C21.1484 18.3481 21.9799 16.4559 21.3257 14.776Z"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.63215}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.05504 7.68387L16.3474 28.9762L28.5145 24.2377L20.2221 2.94537L8.05504 7.68387Z"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.63215}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.8576 6.2031C12.0665 7.2157 11.9553 8.26822 11.5394 9.2148C11.1234 10.1614 10.4233 10.9551 9.53613 11.4861"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.63215}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21.7021 6.74749C20.6895 6.95644 19.637 6.84523 18.6904 6.42929C17.7438 6.01335 16.9501 5.31327 16.4191 4.42607"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.63215}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24.7124 25.7185C24.5035 24.7059 24.6147 23.6534 25.0306 22.7068C25.4465 21.7602 26.1466 20.9665 27.0338 20.4355"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.63215}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.8666 25.174C15.8792 24.9651 16.9318 25.0763 17.8783 25.4922C18.8249 25.9081 19.6187 26.6082 20.1496 27.4954"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.63215}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Rect
        x={15.4424}
        y={5.83057}
        width={13.1101}
        height={22.9427}
        fill={props.bgColor || "#C6D4FF"}
      />
      <Path
        opacity={0.2}
        d="M22.0634 14.1585C23.8632 14.1585 25.3222 15.6175 25.3222 17.4173C25.3222 19.2171 23.8632 20.6761 22.0634 20.6761C20.2637 20.6761 18.8047 19.2171 18.8047 17.4173C18.8047 15.6175 20.2637 14.1585 22.0634 14.1585Z"
        fill={props.color1 || "#A7BBF7"}
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.103453}
      />
      <Path
        opacity={0.2}
        d="M18.1348 8.52305C17.4154 9.24245 16.4941 9.72503 15.4941 9.90714V5.88237H19.5189C19.3368 6.88234 18.8542 7.80365 18.1348 8.52305Z"
        fill="#244BBE"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.103453}
      />
      <Path
        opacity={0.2}
        d="M25.9916 8.52305C25.2722 7.80365 24.7896 6.88234 24.6075 5.88237H28.6323V9.90714C27.6323 9.72503 26.711 9.24245 25.9916 8.52305Z"
        fill="#244BBE"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.103453}
      />
      <Path
        opacity={0.2}
        d="M28.6323 28.9524H24.6075C24.7896 27.9525 25.2722 27.0311 25.9916 26.3117C26.711 25.5923 27.6323 25.1098 28.6323 24.9277V28.9524Z"
        fill="#244BBE"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.103453}
      />
      <Path
        opacity={0.2}
        d="M18.1348 26.3117C18.8542 27.0311 19.3368 27.9525 19.5189 28.9524H15.4941V24.9277C16.4941 25.1098 17.4154 25.5923 18.1348 26.3117Z"
        fill="#244BBE"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={0.103453}
      />
      <Path
        d="M25.3739 17.4173C25.3739 15.589 23.8917 14.1068 22.0634 14.1068C20.2351 14.1068 18.7529 15.589 18.7529 17.4173C18.7529 19.2456 20.2351 20.7278 22.0634 20.7278C23.8917 20.7278 25.3739 19.2456 25.3739 17.4173Z"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.65524}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.4424 5.83075L15.4424 29.0042H28.6843V5.83075H15.4424Z"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.65524}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.5805 5.83064C19.4053 6.86446 18.9128 7.81818 18.1714 8.55963C17.4299 9.30107 16.4762 9.79353 15.4424 9.96875"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.65524}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M28.684 9.96875C27.6502 9.79353 26.6965 9.30107 25.955 8.55963C25.2136 7.81818 24.7211 6.86446 24.5459 5.83064"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.65524}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24.5459 29.0042C24.7211 27.9703 25.2136 27.0166 25.955 26.2752C26.6965 25.5337 27.6502 25.0413 28.684 24.866"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.65524}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.4424 24.866C16.4762 25.0413 17.4299 25.5337 18.1714 26.2752C18.9128 27.0166 19.4053 27.9703 19.5805 29.0042"
        stroke={props.color1 || "#A7BBF7"}
        strokeWidth={1.65524}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1096_12274">
        <Rect
          width={32}
          height={32}
          fill="white"
          transform="matrix(0 -1 1 0 0 32)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
